import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import iframePage from './iframePage.vue';
import { watch, ref, onMounted, onBeforeUnmount } from 'vue';
import WujieVue from 'wujie-vue3';
export default {
  __name: 'index',
  props: {
    alias: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var bus = WujieVue.bus;
    var props = __props;
    var visiblecComputed = ref(props.visible);
    var emit = __emit;
    var iframeEvent = function iframeEvent(event) {
      console.log(event);
      var type = event.data.type;
      if (type === 'closeIframe') {
        handleClose();
      }
      if (type === 'resource') {
        console.log(event.data);
        bus.$emit('openNewResourcePreview', event.data);
      }
      if (type === 'gotoApp') {
        var _event$data = event.data,
          alias = _event$data.alias,
          path = _event$data.path;
        if (alias === 'course') {
          window.open("".concat(location.origin, "/inspirationCentre?inspirationCentre=/course"));
        } else if (alias !== 'lesson') {
          window.open("".concat(location.origin, "/").concat(alias, "?").concat(alias, "=/"));
        }
      }
    };

    // 监听外部props变化
    watch(function () {
      return props.visible;
    }, function (val) {
      visiblecComputed.value = val;
    });
    var handleClose = function handleClose() {
      visiblecComputed.value = false;
      emit('update:visible', false);
    };
    onMounted(function () {
      window.addEventListener('message', iframeEvent);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('message', iframeEvent);
    });
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visiblecComputed.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visiblecComputed.value = $event;
        }),
        width: "100%",
        "z-index": "1000",
        mode: "full-screen",
        class: "help-dialog",
        header: null,
        footer: null,
        onClose: handleClose
      }, {
        default: _withCtx(function () {
          return [_createVNode(iframePage, {
            alias: __props.alias,
            name: __props.name
          }, null, 8, ["alias", "name"])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};